import React from 'react';
import withComponentAuth from '../../hoc/withComponentAuth';
import { Box, Typography } from '@mui/material';
import CatalogManager from './catalog/CatalogManager';

// The Services screen is now the fresh, data-driven Booking & Request catalog.
// The legacy hand-made services list has been retired — catalog Enquiry Types
// auto-mirror into bookable services behind the scenes.
const ServiceManagement = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        p: 2,
        height: '100%',
        maxHeight: '100%',
        overflowY: 'auto',
        scrollbarWidth: 'none',
      }}
    >
      <Typography variant="h5" fontWeight={700} sx={{ mb: 2 }}>
        Services — Booking &amp; Request Catalog
      </Typography>
      <CatalogManager />
    </Box>
  );
};

export default withComponentAuth(ServiceManagement);
